  import axios from 'axios';

  import RedisInfo from './RedisInfo';
  const apiUrl = process.env.REACT_APP_API_URL;
  

  const orderDetails = async (lang,serviceId) => {
      try {
        const responseRedisData = await RedisInfo.redisDetails();
        const parentGroup = responseRedisData.ParentGroup
        console.log("parentGroup in orderDetails:", parentGroup);
        const dealerMapCode=responseRedisData.DealerMapCode
        console.log("dealerMapCode in orderDetails:", dealerMapCode);
        const locCode=responseRedisData.LocCode
        console.log("locCode in orderDetails:", locCode);
        
        
        
        const token =sessionStorage.getItem('token');
      
      // Prepend SERVICE# if not already present
      const serviceIds = serviceId?.replace(/^SERVICE#/, '');

      
      const API_URL = `${apiUrl}/api/v1/orderDetails/getRecentTransactionsForService/${parentGroup}/${dealerMapCode}/${locCode}/${serviceIds}?lang=${lang}`; 
    // const response = await axios.get(API_URL);
    const response = await axios.get(API_URL, {
      headers: {
        Authorization: `Bearer ${token}`
      }
    });
      
        
        return response.data;
      } catch (error) {
        console.error("Error fetching service details:", error);
        throw error;
      }
    };
  
    
    export default { orderDetails };